<template>
  <SoRow class="mb-6">
    <SoCol :default-width="3" :lg-and-down-width="6" :mobile-width="12">
      <SoWidget data-testid="service-config-stats-total">
        <div class="text-center">
          <div class="text-subtitle-2 text-medium-emphasis">
            Total configurations
          </div>
          <SoSkeleton
            v-if="loading"
            width="4em"
            height="2em"
            class="mx-auto mt-1"
          />
          <div
            v-else
            class="text-h4 mt-1"
            data-testid="service-config-stats-total-count"
          >
            {{ totalCount.toLocaleString() }}
          </div>
        </div>
      </SoWidget>
    </SoCol>
    <SoCol :default-width="3" :lg-and-down-width="6" :mobile-width="12">
      <SoWidget data-testid="service-config-stats-active">
        <div class="text-center">
          <div class="text-subtitle-2 text-medium-emphasis">
            Active configurations
          </div>
          <SoSkeleton
            v-if="loading"
            width="4em"
            height="2em"
            class="mx-auto mt-1"
          />
          <div
            v-else
            class="text-h4 mt-1"
            data-testid="service-config-stats-active-count"
          >
            {{ activeCount.toLocaleString() }}
          </div>
        </div>
      </SoWidget>
    </SoCol>
  </SoRow>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoRow from "@/components/SoRow.vue"
  import SoCol from "@/components/SoCol.vue"
  import SoWidget from "@/components/SoWidget.vue"
  import SoSkeleton from "@/components/SoSkeleton.vue"

  export default defineComponent({
    components: {
      SoRow,
      SoCol,
      SoWidget,
      SoSkeleton,
    },
    props: {
      totalCount: {
        type: Number,
        default: 0,
      },
      activeCount: {
        type: Number,
        default: 0,
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
  })
</script>
